import React from 'react';

import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import '@atlaskit/css-reset';

import { CloudComponents } from '@qality/cloud-components';
import { CloudDialogs } from '@qality/cloud-dialogs';
import { CloudModels } from '@qality/cloud-models';
import { CloudServices } from '@qality/cloud-services';
import { ErrorPage, QAlityIssueView } from '@qality/common-pages';
import { ServiceInitializer } from '@qality/common-service';
import { QAlityIssueViewContextProvider } from '@qality/common-state';
import '@qality/common-style/design-tokens/tokens.scss';
import { SentryUtils } from '@qality/premium';

import SentryRecordingPrivacyMaskWrapper from './SentryRecordingPrivacyMaskWrapper';

SentryUtils.initSentry();

async function startRender() {
  CloudComponents.init();
  CloudDialogs.init();
  CloudServices.init();
  CloudModels.init();

  await ServiceInitializer.init();

  const container = document.getElementById(
    'com_soldevelo_apps_test-management_container'
  );

  if (container) {
    ReactDOM.render(
      <Sentry.ErrorBoundary
        fallback={({ error, componentStack }) => (
          <ErrorPage
            error={error}
            message={error.toString()}
            stackTrace={componentStack}
          />
        )}
      >
        <SentryRecordingPrivacyMaskWrapper>
          <QAlityIssueViewContextProvider>
            <QAlityIssueView />
          </QAlityIssueViewContextProvider>
        </SentryRecordingPrivacyMaskWrapper>
      </Sentry.ErrorBoundary>,
      container
    );
  } else {
    throw new Error('no container');
  }
}

window.addEventListener('load', async () => {
  window.AP.theming?.initializeTheming();
  await startRender();
});
